namespace JupitersChoice {

    export enum BigWinLevels { BIGWIN, MEGAWIN, EPICWIN, ULTRAWIN}

    export class BigWinModel {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('CurrencyFormatter') _currencyFormatter: Sapphire.CurrencyFormatter;
        @inject('SoundManager') _soundManager: Sapphire.SoundManager;
        @inject('StateModel') _stateModel: Sapphire.StateModel;
        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('LayerManager') _layerManager: Sapphire.LayerManager;
        @inject('AudioModel') _audioModel: JupitersChoice.AudioModel;

        public static thresholds: number[] = [15,25,50,75];
        private static durations: number[] = [10,15,20,30];
        private _names: string[] = ["bigwin","megawin","epicwin","ultrawin"];
        private _spineNames: string[] = ["bigwin","superwin","megawin","epicwin"];

        private _timeLine: TimelineMax;
        private _currentWinLevel: number;
        private _targetWinLevel: number;
        private _bigWinText: BigWinText;
        private _bigWinBackground: BigWinBackground;
        private _bigWinCounter: Sapphire.Text;
        private _bigWinSpineAnim: Sapphire.SpineAnimation;
        private _bigWinEmitter: Sapphire.Emitter;

        private _winAmount: number;

        private _playing: boolean = false;

        check(winAmount: number, stake: number): boolean {
            return winAmount >= BigWinModel.thresholds[0]*stake;
        }

        get playing():boolean {
            return this._playing;
        }

        play(winAmount: number, stake: number){
            this._playing = true;
            this._winAmount = winAmount;
            this._currentWinLevel = BigWinLevels.BIGWIN;

            this._layerManager.setVisibility('BigWin',true);

            var layer = this._layerManager.getLayerById('BigWin');

            this._bigWinText = this._componentManager.get('BigWinText');
            this._bigWinBackground = this._componentManager.get('BigWinBackground');
            this._bigWinCounter = this._componentManager.get('BigWinCounter');
            this._bigWinSpineAnim = this._componentManager.get('BigWinSpine');
            this._bigWinEmitter = this._componentManager.get('BigWinEmitter');

            this._bigWinText.init('bigwin');
            this._bigWinBackground.init('bigwin');

            this._bigWinSpineAnim.hide();
            this._bigWinText.show();
            this._bigWinBackground.show();
            this._bigWinCounter.show();
            this._bigWinEmitter.show();


            var tgtTextScale = {x: this._bigWinText.scale.x, y:this._bigWinText.scale.y};
            var tgtBGScale = {x: this._bigWinBackground.scale.x, y:this._bigWinBackground.scale.y};
            var tgtWinScale ={x: this._bigWinCounter.scale.x, y:this._bigWinCounter.scale.y};
            
            this._bigWinText.scale.set(0,0);
            this._bigWinBackground.scale.set(0,0);
            this._bigWinCounter.scale.set(0,0);
            
            TweenMax.to(this._bigWinText.scale,1,{
                x:tgtTextScale.x,
                y:tgtTextScale.y,
                ease:Quad.easeOut,
                onComplete: () => {
                    this._bigWinText.startSheen();
                }
            });
            TweenMax.to(this._bigWinBackground.scale,1,{
                x:tgtBGScale.x,
                y:tgtBGScale.y,
                ease:Quad.easeOut
            });
            TweenMax.to(this._bigWinCounter.scale,1,{
                x:tgtWinScale.x,
                y:tgtWinScale.y,
                ease:Quad.easeOut,
                onComplete: () =>{
                    this._bigWinSpineAnim.show();
                    this._bigWinSpineAnim.changeAnimation('bigwin_intro',false,false,() => {
                        this._bigWinSpineAnim.changeAnimation('bigwin_loop',false,true);
                    });
                }
            });

            var count = {
                value: 0
            };

            var thresholds: number[] = [];
            for(var i: number = 0; i<BigWinModel.thresholds.length; ++i){
                thresholds[i] = BigWinModel.thresholds[i]*stake;
            }

            this._audioModel.fadeOutCurrentMusic();

            this._soundManager.play('bigwin_intro');
            this._bigWinCounter.setText("");

            TweenMax.delayedCall(1.5,() => {
                this._soundManager.play('bigwin_loop');
            });

            this._timeLine = new TimelineMax({
                paused: true,
                onUpdate: () => {
                    this._bigWinCounter.setText(this._currencyFormatter.format(count.value));
                    if(Math.round(count.value) == winAmount){
                        //jump to the end
                        if(this._timeLine.progress() < 0.95){
                            this._timeLine.kill();
                            this.onFinish();
                        }
                    }
                },
                onComplete: () => {
                    this.onFinish();
                }
            });

            var stepUp = () => {
                ++this._currentWinLevel;
                this._bigWinText.switchSprite(this._names[this._currentWinLevel]);
                this._bigWinBackground.switchSprite(this._names[this._currentWinLevel]);
                this._bigWinEmitter.stopEmitter({ group: this._names[this._currentWinLevel - 1], killDelay: 4 });
                this._bigWinEmitter.startEmitter(this._names[this._currentWinLevel]);
                this._soundManager.play(this._names[this._currentWinLevel]+'_loop');
                this._bigWinSpineAnim.changeAnimation(this._spineNames[this._currentWinLevel]+'_intro', false, false, () => {
                    this._bigWinSpineAnim.changeAnimation(this._spineNames[this._currentWinLevel]+'_loop',false,true);
                });
            };

            
            this._bigWinEmitter.startEmitter(this._names[this._currentWinLevel]);
            if(winAmount >= thresholds[1]){
                //bigwin
                this._timeLine.add(TweenMax.to(count,11,{
                    value:thresholds[1],
                    ease:Linear.easeNone
                }));
                this._timeLine.call(stepUp);
                if(winAmount >= thresholds[2]){
                    //megawin
                    this._timeLine.add(TweenMax.to(count,10.5,{
                        value:thresholds[2],
                        ease:Linear.easeNone
                    }));
                    this._timeLine.call(stepUp);
                    if(winAmount >= thresholds[3]){
                        //epicwin
                        this._timeLine.add(TweenMax.to(count,10.5,{
                            value:thresholds[3],
                            ease:Linear.easeNone
                        }));
                        this._timeLine.call(stepUp);
                        //ultra
                        this._targetWinLevel = 3;
                        this._timeLine.add(TweenMax.to(count,10.5,{
                            value:winAmount,
                            ease:Quad.easeOut
                        }));
                    }else{
                        this._targetWinLevel = 2;
                        this._timeLine.add(TweenMax.to(count,10.5,{
                            value:winAmount,
                            ease:Quad.easeOut
                        }));
                    }
                }else{
                    this._targetWinLevel = 1;
                    this._timeLine.add(TweenMax.to(count,10.5,{
                        value:winAmount,
                        ease:Quad.easeOut
                    }));
                }
            }else{
                this._targetWinLevel = 0;
                this._timeLine.add(TweenMax.to(count,11,{
                    value:winAmount,
                    ease:Quad.easeOut
                }));
            }

            TweenMax.delayedCall(1, () => {
                TweenMax.delayedCall(0.5, () => {
                    layer.interactive = true;
                    layer.interactiveChildren = true;
                });
                this._soundManager.play('counter_loop');
                this._timeLine.play();
            });
        }

        dismiss(){
            this._timeLine.kill();
            if(this._currentWinLevel < this._targetWinLevel){
                this._bigWinText.switchSprite(this._names[this._targetWinLevel],true,0.3);
                this._bigWinBackground.switchSprite(this._names[this._targetWinLevel],true,0.3);
            }
            this._bigWinCounter.setText(this._currencyFormatter.format(this._winAmount));
            
            this.onFinish();
        }

        private onFinish() {
            this._playing = false;
            this._layerManager.getLayerById('BigWin').interactive = false;
            this._soundManager.stop(this._names[this._currentWinLevel] + '_loop');
            this._soundManager.play('bigwin_outro');
            this._soundManager.stop('counter_loop');
            this._soundManager.play('counter_stop');

            TweenMax.delayedCall(2,() => {
                // Finally, hide layer
                this._componentManager.get('WipeFlare').play(
                    () => {
                        this._bigWinSpineAnim.changeAnimation('bigwin_intro', false, false);
                        this._bigWinSpineAnim.hide();
                        this._bigWinSpineAnim.pause();
                        this._bigWinCounter.hide();
                        this._bigWinBackground.hide();
                        this._bigWinText.hide();
                        this._bigWinText.stopSheen();
                        this._bigWinEmitter.reset();
                        this._bigWinEmitter.hide();
                    },
                    () => {
                        this._layerManager.setVisibility('BigWin', false);
                        if(this._stateModel.currentSubgame == 'FreeGame'){
                            this._eventManager.publish('onFreeGameBigWinComplete');
                        }else{
                            this._eventManager.publish('onBigWinComplete');
                            this._audioModel.setBaseGameMusicToWinning();
                        }
                        this._audioModel.fadeInCurrentMusic();
                    }
                );
            });
        }
    }
}
